import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

import * as React from 'react';
import Icon from '../icon';

var SvgStarFill = function SvgStarFill(props, svgRef) {
  var newProps = _objectSpread(_objectSpread({}, props), {}, {
    name: 'SvgStarFill'
  });

  return /*#__PURE__*/React.createElement(Icon, _objectSpread(_objectSpread({}, newProps), {}, {
    component: function component() {
      return /*#__PURE__*/React.createElement("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 1000 1000",
        fill: "currentColor",
        focusable: false,
        "aria-hidden": "true",
        ref: svgRef
      }, /*#__PURE__*/React.createElement("path", {
        d: "M500.122 852.313L222.594 974.61c-15.569 6.86-33.752-.199-40.612-15.767a30.806 30.806 0 01-2.46-15.526l30.551-301.737L8.001 415.427C-3.335 402.74-2.24 383.266 10.447 371.93a30.806 30.806 0 0114.005-7.136l296.41-64.187L473.502 38.54c8.563-14.702 27.423-19.678 42.125-11.115a30.806 30.806 0 0111.115 11.115l152.64 262.067 296.41 64.187c16.628 3.6 27.188 20 23.588 36.627a30.806 30.806 0 01-7.137 14.006L790.171 641.58l30.55 301.737c1.714 16.927-10.618 32.038-27.545 33.752-5.3.537-10.65-.31-15.526-2.459L500.122 852.313z",
        fillRule: "evenodd"
      }));
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFill);
export default ForwardRef;